import { render, staticRenderFns } from "./AppSimpleDatePicker.vue?vue&type=template&id=21fd4ce6&scoped=true&"
import script from "./AppSimpleDatePicker.vue?vue&type=script&lang=ts&"
export * from "./AppSimpleDatePicker.vue?vue&type=script&lang=ts&"
import style0 from "./AppSimpleDatePicker.vue?vue&type=style&index=0&id=21fd4ce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fd4ce6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDatePicker,VSpacer,VTextField})
